import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    extJobSchedules: "api/v1/jobs",
    putURL: "api/v1/jobs/",

}

export const postExtJobschedules = (payload: types.IExtJobScheduleParams) =>
    Api.post(apiUrls.extJobSchedules, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const putJobSchedulesdata = (param: string, payload: types.IJobSchedulesPutReq) =>
    Api.put(apiUrls.putURL + `${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const deleteJobSchedules = (param: string) =>
    Api.delete(apiUrls.putURL + `${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });